import { Box, Button, FormControl, FormHelperText, FormLabel, Stack, TextField } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { tempAssPattern } from "../../helpers/constant/registerPattern";
import { EMPLOYER_TEMPLATE_TYPE_LIST } from "../../helpers/constant/employerTemplateConstant";
import Select from "react-select";

const CreateTemplateCategory = ({ onClose, onSubmit }) => {
  const { control, handleSubmit } = useForm();
  const typeOptions = Object.values(EMPLOYER_TEMPLATE_TYPE_LIST);

  return (
    <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
      <Box>
        <Controller
          control={control}
          name="category"
          defaultValue=""
          render={({ field: { value, onChange }, fieldState: { invalid, error } }) => (
            <FormControl fullWidth required error={!!(invalid && error.message)}>
              <FormLabel>Category</FormLabel>
              <Select
                className={"select-dropdown-menu select-dropdown-menu-custom"}
                classNamePrefix={"select-dropdown-styles"}
                isMulti={false}
                isSearchable={true}
                menuPlacement="bottom"
                options={typeOptions}
                value={value}
                onChange={(newValue) => {
                  onChange(newValue);
                }}
              />
              <FormHelperText error={invalid}>{invalid && error.message}</FormHelperText>
            </FormControl>
          )}
          rules={tempAssPattern.category}
        />

        <Stack direction={"row"} justifyContent={"flex-end"} spacing={2} mt={2}>
          <Button variant={"text"} onClick={onClose} size={"small"}>
            Cancel
          </Button>
          <Button type={"submit"} variant={"contained"} size={"small"}>
            Create Template
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default CreateTemplateCategory;
